import Api from '../../utils/api';
import { apiRequest } from '../api';
import {
  CHAT_LOGIN,
  CHAT_VERIFY_OTP,
  CHAT_GET_CHATWOOT_TOKEN,
  CHAT_SET_AUTH_TOKEN,
} from '../constants';
import * as proto from './_prototype';

export * from './_prototype';

// IAM API may return data directly or wrapped in { data, success }.
// Use `e?.data ?? e` to handle both formats safely.

// LOGIN_METHOD_SMS. The backend's FuzzyLogin derives login_mode purely from
// this field, so an SMS method always takes the OTP-delivery path regardless
// of SUPPORTED_LOGIN_SMS / FORCE_WHATSAPP_LOGIN.
const LOGIN_METHOD_SMS = 1;

export const postLogin = (mobile: string) => apiRequest<proto.LoginRes>({
  label: CHAT_LOGIN,
  action: Api.iamBackend('v1/iam/fuzzy/login', {
    method: 'POST',
    data: { mobile, login_method: LOGIN_METHOD_SMS },
  }),
  fulfilled: (e, _dispatch) => e?.data ?? e,
  rejected: (e) => e,
});

export const postVerifyOTP = (params: proto.VerifyOTPReq) => apiRequest<proto.VerifyOTPRes>({
  label: CHAT_VERIFY_OTP,
  action: Api.iamBackend('v1/iam/verify', {
    method: 'POST',
    data: params,
  }),
  fulfilled: (e, dispatch) => {
    const data = (e?.data ?? e) as proto.VerifyOTPRes | undefined;
    if (data?.token) {
      dispatch({ type: CHAT_SET_AUTH_TOKEN, payload: data.token });
    }
    return data;
  },
  rejected: (e) => e,
});

export const getChatwootToken = (authToken: string) => apiRequest<proto.ChatwootTokenRes>({
  label: CHAT_GET_CHATWOOT_TOKEN,
  action: Api.connectBackend('v3/chat/hash', {
    method: 'GET',
    headers: { authorization: authToken },
  }),
  fulfilled: (e, _dispatch) => e?.data ?? e,
  rejected: (e) => e,
});
